export default __webpack_public_path__ + "static/media/L_matrix.823c5617.png";